import React from 'react';
import TimelineEventCard from './TimelineEventCard';

/**
 * Groups events by month and renders them along a vertical spine.
 * Events without dates are grouped under "Date Unknown" at the bottom.
 */
function TimelineView({ events, showCompany = true, onEventUpdated }) {
  // Group events by month (YYYY-MM)
  const groups = [];
  const groupMap = new Map();

  events.forEach((event) => {
    const key = event.event_date ? event.event_date.substring(0, 7) : '__undated__';
    if (!groupMap.has(key)) {
      groupMap.set(key, []);
    }
    groupMap.get(key).push(event);
  });

  // Convert to sorted array
  groupMap.forEach((items, key) => {
    groups.push({ key, events: items });
  });

  // Sort: dated groups descending, undated at end
  groups.sort((a, b) => {
    if (a.key === '__undated__') return 1;
    if (b.key === '__undated__') return -1;
    return b.key.localeCompare(a.key);
  });

  const formatMonthLabel = (key) => {
    if (key === '__undated__') return 'Date Unknown';
    try {
      const [year, month] = key.split('-');
      const date = new Date(parseInt(year), parseInt(month) - 1);
      return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    } catch {
      return key;
    }
  };

  if (events.length === 0) {
    return (
      <div className="timeline-empty">
        <div className="timeline-empty-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <h3>No timeline events found</h3>
        <p>Try adjusting your filters or broadening your search.</p>
      </div>
    );
  }

  return (
    <div className="timeline-view">
      <div className="timeline-spine" />
      {groups.map((group) => (
        <div key={group.key} className="timeline-month-group">
          <div className="timeline-month-label">
            {formatMonthLabel(group.key)}
            <span className="timeline-month-count">{group.events.length}</span>
          </div>
          {group.events.map((event) => (
            <TimelineEventCard
              key={event.id}
              event={event}
              showCompany={showCompany}
              onEventUpdated={onEventUpdated}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default TimelineView;
